import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React from 'react'

export const DetailHeader = ({ headerData }) => {
  return (
    <Vertical
      className='p-4'
      justifyContent='space-between'
      style={{
        width: '100%',
        background: 'var(--theme-color-1)',
        maxHeight: '140px',
        minHeight: 'min-content',
      }}
    >
      <Horizontal>
        <Texto appearance='white' category={'h4'} align='left'>
          Layer Breakdown
        </Texto>
      </Horizontal>
      <Horizontal>
        <Vertical>
          <Horizontal alignItems={'center'}>
            <Texto appearance='white' category='heading-small' className='mr-4 mt-0'>
              SITE
            </Texto>
            <Texto appearance='white' category='h3'>
              {headerData?.site ?? ' '}
            </Texto>
          </Horizontal>
        </Vertical>
        <Vertical>
          <Horizontal justifyContent='flex-end' alignItems={'center'}>
            <Texto category='heading-small' appearance='white' className='mr-4 mt-0'>
              PRODUCT
            </Texto>
            <Texto appearance='white' category='h3'>
              {headerData?.product ?? ''}
            </Texto>
          </Horizontal>
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}
